import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, Typography, Button, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import { List, Datagrid, TextField, FunctionField, SimpleList } from 'react-admin';
import ImageGalleryDialog from "./components/ImageGalleryDialog";
import { customTheme } from "./customTheme";
import moment from 'moment';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';   
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles({
    parkingListHead: {
		color: "#777",
    },
    darkText: {
        color: "#111"
    }
});

const renderGender = gender => gender ? gender[0] : "";
const renderDose = (prev_dose, served) => prev_dose ? <div>2 - {served ? "84 days passed" : <span style={{ color: customTheme.palette.error.main }}>84 days not passed</span>}</div> : 1;
const getImages = record => ([record["government_id"], record["organization_id"], record["spouse_government_id"]]);
const renderTime = time => moment(time).format("hh:mm A");
export function VaccineDriveList(props) {
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

	return (<List
            {...props}
            sort={{ field: "appointed_slot", order: "ASC" }}
            bulkActionButtons={false}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>+91 {record["mobile_number"]}</div>
                        <div style={{ fontSize: 15 }} >{renderTime(record["appointed_slot"])}</div>
                    </div>}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["name"]} — {record["beneficiary_id"]}</div>
                        <div>Age/Gender: {record["age"]}/{renderGender(record["gender"])}</div>
                        <div>Dose: {renderDose(record["prev_dose"], record["cooldown_period_served"])}</div>
                        {record["spouse_beneficiary_id"] && <>
                            <div style={{ color: "#000" }}>Spouse's Details</div>
                            <div style={{ color: customTheme.palette.secondary.main }}>{record["spouse_name"]} — {record["spouse_beneficiary_id"]}</div>
                            <div>Age/Gender: {record["spouse_age"]}/{renderGender(record["spouse_gender"])}</div>
                            <div>Dose: {renderDose(record["spouse_prev_dose"], record["spouse_cooldown_period_served"])}</div>
                        </>}
                        <ImageGalleryDialog record={record} getImages={getImages} style={{ textAlign: "left" }} />
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                />
            :
                <Datagrid classes={{ headerCell: classes.parkingListHead }}>
                    <TextField label="Mobile Number" source="mobile_number" />
                    <TextField label="Beneficiary ID" source="beneficiary_id" />
                    <TextField label="Name" source="name" />
                    <TextField label="Age" source="age" />
                    <FunctionField label="Gender" render={row => renderGender(row["gender"])} />
                    <FunctionField label="Dose" render={row => renderDose(row["prev_dose"], row["cooldown_period_served"])} />
                    <TextField label="Spouse's Beneficiary ID" source="spouse_beneficiary_id" />
                    <TextField label="Spouse's Name" source="spouse_name" />
                    <TextField label="Spouse's Age" source="spouse_age" />
                    <FunctionField label="Spouse's Gender" render={row => renderGender(row["spouse_gender"])} />
                    <FunctionField label="Spouse's Dose" render={row => row["spouse_beneficiary_id"] ? renderDose(row["spouse_prev_dose"], row["spouse_cooldown_period_served"]) : null} />
                    <ImageGalleryDialog label="Documents" getImages={getImages} />
                    <FunctionField label="Slot" render={row => renderTime(row["appointed_slot"])} className={classes.darkText} />
                    <CustomApprovalButton label="Vaccination" source="vaccinated" />
                </Datagrid>
            }
        </List>
    );
};

function ApprovalButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };
  
    const closeDialog = () => {
        setDialogVisible(false);
    };
    
    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, resource, basePath } = props;
        const data = {
            newData: {
                vaccinated: 1,
            },
            oldData: record,
        };
        dispatchCrudUpdate(resource, record.id, data, record, basePath, "/vaccineDrive");
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", flex: 1 }}>
            {record[source] ?
                <Typography style={{ fontWeight: "bold", color: customTheme.palette.primary.main }}><CheckCircleIcon /> Vaccinated</Typography>
            :
                <Button variant="contained" color="primary" style={{ marginTop: isSmallDevice ? 10 : 0 }} onClick={openDialog}>Vaccinate</Button>
            }

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure the person is Vaccinated?</DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>No</Button>
                    <Button color="primary" onClick={handleUpdate}>Vaccinated</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
  
ApprovalButton.defaultProps = {
    redirect: 'list',
    undoable: false
};
  
const CustomApprovalButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(ApprovalButton);